
import { Vue, Component } from 'vue-property-decorator';
import { vueCanvasPoster } from 'vue-canvas-poster';
import { Popup, Button } from 'vant';
Vue.use(Popup).use(Button);
@Component({
  components: {
    vueCanvasPoster,
  },
})
export default class Canvas extends Vue {
  showCanvas = false;
  src = '';
  testData = 'huhan';
  painting = {};
  created() {
    this.painting = {
      name: Canvas,
      width: '550px',
      height: '876px',
      background: '#f4f5f7',
      views: [
        {
          type: 'image',
          url:
            'https://tgoods.top1buyer.com/res/testfile/imgs/20190702180744/MR9600-Pink/2.jpg',
          css: {
            top: '20px',
            left: '36px',
            borderRadius: '40px',
            width: '80px',
            height: '80px',
          },
        },
        {
          type: 'text',
          text: this.testData,
          css: {
            top: '48px',
            left: '136px',
            width: '360px',
            maxLines: 1,
            fontSize: '26px',
          },
        },
        {
          type: 'rect',
          css: {
            top: '120px',
            left: '12px',
            color: '#fff',
            width: '526px',
            height: '540px',
            borderRadius: '10px',
          },
        },
        {
          type: 'image',
          url:
            'https://tgoods.top1buyer.com/res/testfile/imgs/20190702180744/MR9600-Pink/2.jpg',
          css: {
            top: '150px',
            left: '25px',
            width: '332px',
            height: '332px',
          },
        },
        {
          type: 'image',
          url:
            'https://tgoods.top1buyer.com/res/testfile/imgs/20190702180744/MR9600-Pink/2.jpg',
          css: {
            top: '150px',
            left: '364px',
            width: '160px',
            height: '160px',
          },
        },
        {
          type: 'image',
          url:
            'https://tgoods.top1buyer.com/res/testfile/imgs/20190702180744/MR9600-Pink/3.jpg',
          css: {
            top: '320px',
            left: '364px',
            width: '160px',
            height: '160px',
          },
        },
        {
          type: 'text',
          text: '18987、安奈儿童装上衣条纹童装上衣条纹童装上衣 条纹童装上衣',
          css: {
            top: '507px',
            left: '25px',
            color: '#666666',
            fontSize: '22px',
            width: '450px',
            lineHeight: '33px',
            maxLines: 2,
          },
        },
        {
          type: 'text',
          text: '劲爆价:',
          css: {
            top: '608px',
            left: '26px',
            color: '#666666',
            fontSize: '24px',
          },
        },
        {
          type: 'text',
          text: '¥39.00',
          css: {
            top: '601px',
            left: '116px',
            color: '#E5463E',
            fontSize: '36px',
            fontWeight: 'bold',
          },
        },
        {
          type: 'text',
          text: '¥259.00',
          css: {
            top: '609px',
            left: '243px',
            color: '#999999',
            fontSize: '26px',
            fontWeight: 'bold',
            textDecoration: 'line-through',
          },
        },
        {
          type: 'rect',
          css: {
            top: '647px',
            left: '439px',
            color: '#fff',
            width: '28px',
            height: '28px',
            rotate: 45,
          },
        },
        {
          type: 'text',
          text: '长按或扫描二维码',
          css: {
            fontSize: '18px',
            color: '#999999',
            bottom: '22px',
            left: '385px',
          },
        },
        // 本地图片
        {
          type: 'image',
          url:
            'https://tgoods.top1buyer.com/res/testfile/imgs/20190702180744/MR9600-Pink/2.jpg',
          css: {
            left: '26px',
            bottom: '22px',
            width: '218px',
            height: '24px',
          },
        },
        {
          type: 'qrcode',
          content: 'https://github.com/sunniejs/vue_canvas_poster',
          css: {
            bottom: '50px',
            right: '26px',
            color: '#000',
            width: '130px',
            height: '130px',
          },
        },
      ],
    };
  }
  success(src: any) {
    // 设置img的src
    this.src = src;
  }
  fail(err: any) {
    console.log('fail', err);
  }
}
